<template>
  <div>
    <el-upload class="avatar-uploader"
               :action="action"
               :headers="headers"
               :limit="limit"
               :list-type="listType"
               :file-list="fileList"
               :on-preview="handlePreview"
               :on-remove="onRemove"
               :on-success="onSuccess"
               :before-upload="beforeUpload">
      <i class="el-icon-plus"
         v-if="listType!='text'"></i>
      <el-button size="small"
                 v-else
                 type="primary">点击上传文件</el-button>
      <div slot="tip"
           v-if="listType!='text'"
           class="el-upload__tip"
           style="color:red;">{{tipInfo}}</div>
      <div slot="tip"
           v-else
           class="el-upload__tip"
           style="color:red;">{{tipInfo}}</div>
    </el-upload>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%"
           :src="dialogImageUrl"
           alt="">
    </el-dialog>
  </div>
</template>
<script>
import _request from '@/utils/request.js'
import _cookies from 'js-cookie'
export default {
  props: {
    headers: {
      default: function () {
        return {
          "staff_center_login_key": _cookies.get('staff_center_login_key') || ''
        }
      }
    },
    fileList: {
      type: Array,
    },
    listType: {
      default: 'picture-card'
    },
    tipInfo: {
      default: '说明：可上传客户要求的logo、素材图等，供相关部门使用，支持 .ai、.jpg、.png、.xlsx格式文件'
    },
    indexof: {
      default: ''
    },
    limit: {
      default: 5
    }
  },
  data () {
    return {
      action: _request.getCrmUrl('/api/file/uploadFile'),
      dialogImageUrl: '',
      dialogVisible: false,


    }
  },

  methods: {
    onSuccess (response, file, fileList) {
      this.$emit('onSuccess', response, file, fileList, this.indexof)
    },
    onRemove (file, fileList, indexof) {
      this.$emit('onRemove', file, fileList, this.indexof)
    },
    beforeUpload (e) {
      this.$emit('beforeUpload', e)
    },
    handlePreview (file) {
      if (this.indexof != 1) {
        this.dialogImageUrl = file.url;
        if (file.url.indexOf('jpg') > 0 || file.url.indexOf('png') > 0) {
          this.dialogVisible = true;
        } else {
          this.dialogVisible = false;
        }
      }

    }
  }
}

</script>